import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    userName: undefined,
    password: undefined,
    selectedTableItem :null,
    activeUSPDetails:null,
    activeSPDetails:null
}

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        setCreds: (state, action) => {
            state.userName = action.payload.userName;
            state.password = action.payload.password;
        },
        setSelectedtableitem: (state, action) =>{
            state.selectedTableItem=action.payload.selectedTableItem;
        },
        setUSPDetails:(state, action) =>{
            state.activeUSPDetails=action.payload.selectedTableItem;
        },
        setSPDetails:(state, action) =>{
            state.activeSPDetails=action.payload.selectedTableItem;
        },
    }
})

export const { setCreds, setSelectedtableitem, setUSPDetails, setSPDetails } = loginSlice.actions

export default loginSlice.reducer